import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEncuestas, crearEncuesta, eliminarEncuesta, fetchPreguntasByEncuestaId } from '../../redux/encuestasSlice';
import { Table, Button, Modal, Form, Alert,  ButtonGroup } from 'react-bootstrap';
import Swal from 'sweetalert2';
import api from '../../utils/axiosConfig';

// --- Normalizador defensivo para alternativas ---
// Asegura que siempre tengamos un Array para poder usar .map() sin romper el render.
export const normalizeAlternativas = (value) => {
  if (value == null) return [];
  if (Array.isArray(value)) return value;

  if (typeof value === 'string') {
    const s = value.trim();
    if (!s) return [];
    try {
      const parsed = JSON.parse(s);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && typeof parsed === 'object') return Object.values(parsed);
      return [s];
    } catch (e) {
      if (s.includes(',')) return s.split(',').map(v => v.trim()).filter(Boolean);
      return [s];
    }
  }

  if (typeof value === 'object') {
    try {
      return Array.isArray(value) ? value : Object.values(value);
    } catch (e) {
      return [];
    }
  }
  return [];
};
// --- fin normalizador ---


const EncuestasPage = () => {
  const dispatch = useDispatch();
  const { encuestas, error, preguntas, loading } = useSelector((state) => state.encuestas);

  useEffect(() => {
    dispatch(fetchEncuestas());
  }, [dispatch]);

  const [modalState, setModalState] = useState({
    showEncuestaModal: false,
    showPreguntaModal: false,
  });
  const [encuestaForm, setEncuestaForm] = useState({ titulo: '', descripcion: '', enviarNotificacion: false });
  const [preguntaForm, setPreguntaForm] = useState({
    pregunta: '',
    tipoRespuesta: 'opcion_multiple',
    alternativas: [''],
  });
  const [selectedEncuestaId, setSelectedEncuestaId] = useState(null);
  const [editMode, setEditMode] = useState({ isEditing: false, preguntaId: null });
  const [errors, setErrors] = useState({ encuesta: null, pregunta: null });
  const [isCreatingEncuesta, setIsCreatingEncuesta] = useState(false);
  const [isUpdatingPregunta, setIsUpdatingPregunta] = useState(false);

  const handleShowModal = (modalName, state) => {
    setModalState((prev) => ({ ...prev, [modalName]: state }));
  };

  const handleChangeEncuesta = (e) => {
    const { name, value } = e.target;
    setEncuestaForm((prev) => ({ ...prev, [name]: value }));

    // Validación en tiempo real para el título
    if (name === 'titulo') {
      if (value.length <= 10) {
        setErrors((prev) => ({ ...prev, encuesta: 'El título debe tener más de 10 caracteres.' }));
      } else {
        setErrors((prev) => ({ ...prev, encuesta: null }));
      }
    }

    // Validación en tiempo real para la descripción
    if (name === 'descripcion') {
      if (value.length > 500) {
        setErrors((prev) => ({ ...prev, encuesta: 'La descripción no debe exceder los 500 caracteres.' }));
      } else {
        setErrors((prev) => ({ ...prev, encuesta: null }));
      }
    }
  };

  const handleCrearEncuesta = async (e) => {
    e.preventDefault();

    // Validación para el título
    if (encuestaForm.titulo.length <= 10) {
      setErrors((prev) => ({ ...prev, encuesta: 'El título debe tener más de 10 caracteres.' }));
      return;
    }

    // Validación para la descripción
    if (encuestaForm.descripcion && encuestaForm.descripcion.length > 500) {
      setErrors((prev) => ({ ...prev, encuesta: 'La descripción no debe exceder los 500 caracteres.' }));
      return;
    }

    setIsCreatingEncuesta(true);

    try {
      await dispatch(crearEncuesta({ ...encuestaForm, activo: true })).unwrap();
      handleShowModal('showEncuestaModal', false);
      setEncuestaForm({ titulo: '', descripcion: '' });
      setErrors((prev) => ({ ...prev, encuesta: null }));
      dispatch(fetchEncuestas());
      Swal.fire({
        icon: 'success',
        title: 'Encuesta creada',
        text: 'La encuesta se ha creado correctamente.',
      });
    } catch (err) {
      setErrors((prev) => ({ ...prev, encuesta: err.message || 'Error al crear la encuesta.' }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message || 'Error al crear la encuesta.',
      });
    } finally {
      setIsCreatingEncuesta(false);
    }
  };

  const handleEliminarEncuesta = (id) => {
 
  
  Swal.fire({
    title: '¿Estás seguro?',
    text: "Esta acción no se puede deshacer",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      
      
      dispatch(eliminarEncuesta(id))
        .then((action) => {
          
          
          if (action.error) {
            console.error('[ERROR] eliminación fallida:', action.error);
            throw new Error(action.error.message || 'Error en la acción de eliminación');
          }
          
          
          return dispatch(fetchEncuestas());
        })
        .then(() => {
          
          Swal.fire({
            icon: 'success',
            title: 'Encuesta eliminada',
            text: 'La encuesta se ha eliminado correctamente.',
          });
        })
        .catch((err) => {
          console.error('[ERROR] En el flujo de eliminación:', err);
          console.error('[ERROR] Detalles completos:', JSON.stringify(err, null, 2));
          
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err.message || 'Error al eliminar la encuesta.',
          });
        });
    }
  });
};

  const handleAbrirModalPregunta = (id) => {
    setSelectedEncuestaId(id);
    dispatch(fetchPreguntasByEncuestaId(id));
    handleShowModal('showPreguntaModal', true);
  };

  const handleChangePregunta = (e) => {
    const { name, value } = e.target;
    setPreguntaForm((prev) => ({ ...prev, [name]: value }));

    // Validación en tiempo real para la pregunta
    if (name === 'pregunta') {
      if (value.length <= 10) {
        setErrors((prev) => ({ ...prev, pregunta: 'La pregunta debe tener más de 10 caracteres.' }));
      } else {
        setErrors((prev) => ({ ...prev, pregunta: null }));
      }
    }
  };

  const handleCrearPregunta = async () => {
    const { pregunta, tipoRespuesta, alternativas } = preguntaForm;

    // Validar longitud de la pregunta
    if (pregunta.trim().length <= 10) {
      setErrors((prev) => ({ ...prev, pregunta: 'La pregunta debe tener más de 10 caracteres.' }));
      return;
    }

    // Validar alternativas en preguntas de opción múltiple
    if (tipoRespuesta === 'opcion_multiple') {
      const alternativasValidas = alternativas.filter((alt) => alt.trim().length > 1);
      if (alternativasValidas.length < 2) {
        setErrors((prev) => ({ ...prev, pregunta: 'Debe haber al menos dos alternativas válidas, con más de un carácter.' }));
        return;
      }
    }

    setIsUpdatingPregunta(true);

    try {
      const payload = {
        pregunta: pregunta.trim(),
        tipo_respuesta: tipoRespuesta,
        alternativas: tipoRespuesta === 'opcion_multiple'
          ? alternativas.filter((alt) => alt.trim().length > 1)
          : null,
      };

      if (editMode.isEditing) {
        await api.put(`/api/encuestas/preguntas/${editMode.preguntaId}`, payload);
        Swal.fire({
          icon: 'success',
          title: 'Pregunta actualizada',
          text: 'La pregunta se ha actualizado correctamente.',
        });
      } else {
        await api.post(`/api/encuestas/${selectedEncuestaId}/preguntas`, payload);
        Swal.fire({
          icon: 'success',
          title: 'Pregunta añadida',
          text: 'La pregunta se ha añadido correctamente.',
        });
      }

      dispatch(fetchPreguntasByEncuestaId(selectedEncuestaId));
      setPreguntaForm({ pregunta: '', tipoRespuesta: 'opcion_multiple', alternativas: [''] });
      setEditMode({ isEditing: false, preguntaId: null });
      setErrors({});
    } catch (error) {
      console.error('Error al gestionar la pregunta:', error);
      setErrors((prev) => ({
        ...prev,
        pregunta: error.response?.data?.message || 'Error al gestionar la pregunta.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error al gestionar la pregunta.',
      });
    } finally {
      setIsUpdatingPregunta(false);
    }
  };

  const handleEliminarPregunta = async (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: "Esta acción no se puede deshacer",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/api/encuestas/preguntas/${id}`);
          dispatch(fetchPreguntasByEncuestaId(selectedEncuestaId));
          Swal.fire({
            icon: 'success',
            title: 'Pregunta eliminada',
            text: 'La pregunta se ha eliminado correctamente.',
          });
        } catch (error) {
          console.error('Error al eliminar pregunta:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Error al eliminar la pregunta.',
          });
        }
      }
    });
  };

  const handleEditarPregunta = (id, preguntaText, tipo, alternativasArray) => {
    setEditMode({ isEditing: true, preguntaId: id });
    setPreguntaForm({ pregunta: preguntaText, tipoRespuesta: tipo, alternativas: alternativasArray || [''] });
  };

  const handleAddAlternativa = () => setPreguntaForm((prev) => ({ ...prev, alternativas: [...normalizeAlternativas(prev.alternativas), ''] }));

  const handleRemoveAlternativa = (index) => {
    setPreguntaForm((prev) => ({
      ...prev,
      alternativas: normalizeAlternativas(prev.alternativas).filter((_, i) => i !== index),
    }));
  };

  const handleAlternativaChange = (value, index) => {
    setPreguntaForm((prev) => {
      const nuevasAlternativas = [...normalizeAlternativas(prev.alternativas)];
      nuevasAlternativas[index] = value;

      if (prev.tipoRespuesta === 'opcion_multiple') {
        const alternativasValidas = nuevasAlternativas.filter((alt) => alt.trim().length > 1);
        if (alternativasValidas.length < 2) {
          setErrors((prevErrors) => ({ ...prevErrors, pregunta: 'Debe haber al menos dos alternativas válidas, con más de un carácter.' }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, pregunta: null }));
        }
      }

      return { ...prev, alternativas: nuevasAlternativas };
    });
  };

  return (
    <div className="container-fluid py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="h3 mb-0">Gestión de Encuestas</h1>
        <Button 
          onClick={() => handleShowModal('showEncuestaModal', true)} 
          variant="success"
          className="d-flex align-items-center"
        >
          <i className="bi bi-plus-circle me-2"></i>
          <span className="d-none d-sm-inline">Crear Encuesta</span>
        </Button>
      </div>

      {error && (
        <Alert variant="danger" className="mt-3">
          {error.message || (typeof error === 'string' ? error : 'Ocurrió un error')}
        </Alert>
      )}
      {errors.encuesta && <Alert variant="danger">{errors.encuesta}</Alert>}
      {errors.pregunta && <Alert variant="danger">{errors.pregunta}</Alert>}

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="d-block d-md-none alert alert-info mb-3">
            <i className="bi bi-phone me-1"></i>
            Desliza horizontalmente para ver todas las columnas
          </div>
          
          <div className="table-responsive">
            <Table striped bordered hover className="small">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Título</th>
                  <th className="d-none d-md-table-cell">Descripción</th>
                  <th>Estado</th>
                  <th className="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {encuestas.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-muted">
                      No hay encuestas registradas
                    </td>
                  </tr>
                ) : (
                  (Array.isArray(encuestas) ? encuestas : []).map((encuesta, index) => (
                    <tr key={encuesta.id}>
                      <td>{index + 1}</td>
                      <td title={encuesta.titulo} className="text-truncate" style={{maxWidth: '150px'}}>
                        {encuesta.titulo}
                      </td>
                      <td 
                        title={encuesta.descripcion} 
                        className="d-none d-md-table-cell text-truncate" 
                        style={{maxWidth: '200px'}}
                      >
                        {encuesta.descripcion || '-'}
                      </td>
                      <td className="text-center">
                        <span className={`badge ${encuesta.activo ? 'bg-success' : 'bg-secondary'}`}>
                          {encuesta.activo ? 'Activa' : 'Inactiva'}
                        </span>
                      </td>
                      <td className="text-center">
                        <ButtonGroup size="sm">
                          <Button
                            variant="outline-primary"
                            onClick={() => handleAbrirModalPregunta(encuesta.id)}
                            title="Gestionar preguntas"
                          >
                            <i className="bi bi-list-check"></i>
                            <span className="d-none d-lg-inline ms-1">Preguntas</span>
                          </Button>
                          <Button
                            variant="outline-danger"
                            onClick={() => handleEliminarEncuesta(encuesta.id)}
                            title="Eliminar"
                          >
                            <i className="bi bi-trash"></i>
                            <span className="d-none d-lg-inline ms-1">Eliminar</span>
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </>
      )}

      <Modal show={modalState.showEncuestaModal} onHide={() => handleShowModal('showEncuestaModal', false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-plus-circle me-2"></i>
            Crear Nueva Encuesta
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCrearEncuesta}>
            <Form.Group className="mb-3" controlId="titulo">
              <Form.Label>Título *</Form.Label>
              <Form.Control
                type="text"
                name="titulo"
                placeholder="Ingrese el título de la encuesta (mínimo 10 caracteres)"
                value={encuestaForm.titulo}
                onChange={handleChangeEncuesta}
                isInvalid={errors.encuesta && encuestaForm.titulo.length <= 10}
              />
              <Form.Control.Feedback type="invalid">
                El título debe tener más de 10 caracteres.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="descripcion">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="descripcion"
                placeholder="Ingrese una descripción opcional (máximo 500 caracteres)"
                value={encuestaForm.descripcion}
                onChange={handleChangeEncuesta}
                isInvalid={errors.encuesta && encuestaForm.descripcion.length > 500}
              />
              <Form.Control.Feedback type="invalid">
                La descripción no debe exceder los 500 caracteres.
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="enviarNotificacion">
              <Form.Check
                type="checkbox"
                label="Enviar notificación por email a todos los socios"
                name="enviarNotificacion"
                checked={encuestaForm.enviarNotificacion}
                onChange={(e) => setEncuestaForm(prev => ({
                  ...prev,
                  enviarNotificacion: e.target.checked
                }))}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => handleShowModal('showEncuestaModal', false)}>
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={handleCrearEncuesta}
            disabled={isCreatingEncuesta || encuestaForm.titulo.length <= 10}
          >
            {isCreatingEncuesta ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Creando...
              </>
            ) : (
              <>
                <i className="bi bi-save me-1"></i>
                Guardar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalState.showPreguntaModal} onHide={() => handleShowModal('showPreguntaModal', false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-list-check me-2"></i>
            Gestionar Preguntas
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="pregunta">
              <Form.Label>Pregunta *</Form.Label>
              <Form.Control
                type="text"
                name="pregunta"
                placeholder="Ingrese la pregunta (mínimo 10 caracteres)"
                value={preguntaForm.pregunta}
                onChange={handleChangePregunta}
                isInvalid={errors.pregunta && preguntaForm.pregunta.length <= 10}
              />
              <Form.Control.Feedback type="invalid">
                La pregunta debe tener más de 10 caracteres.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="tipoRespuesta">
              <Form.Label>Tipo de Respuesta *</Form.Label>
              <Form.Select
                name="tipoRespuesta"
                value={preguntaForm.tipoRespuesta}
                onChange={handleChangePregunta}
              >
                <option value="opcion_multiple">Opción Múltiple</option>
                <option value="abierta">Abierta</option>
              </Form.Select>
            </Form.Group>

            {preguntaForm.tipoRespuesta === 'opcion_multiple' && (
              <Form.Group className="mb-3" controlId="alternativas">
                <Form.Label>Alternativas *</Form.Label>
                {normalizeAlternativas(preguntaForm.alternativas).map((alt, index) => (
                  <div key={index} className="d-flex align-items-center mb-2">
                    <Form.Control
                      type="text"
                      placeholder={`Alternativa ${index + 1}`}
                      value={alt}
                      onChange={(e) => handleAlternativaChange(e.target.value, index)}
                      isInvalid={alt.trim().length > 0 && alt.trim().length <= 1}
                    />
                    <Form.Control.Feedback type="invalid">
                      Cada alternativa debe tener más de un carácter.
                    </Form.Control.Feedback>
                    <Button variant="outline-danger" size="sm" className="ms-2" onClick={() => handleRemoveAlternativa(index)}>
                      <i className="bi bi-trash"></i>
                    </Button>
                  </div>
                ))}
                <Button variant="outline-success" size="sm" onClick={handleAddAlternativa}>
                  <i className="bi bi-plus-circle me-1"></i>
                  Añadir Alternativa
                </Button>
              </Form.Group>
            )}
          </Form>

          <div className="d-flex justify-content-between mt-4">
            <Button
              variant={editMode.isEditing ? "warning" : "primary"}
              onClick={handleCrearPregunta}
              disabled={isUpdatingPregunta || preguntaForm.pregunta.length <= 10}
            >
              {isUpdatingPregunta ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  {editMode.isEditing ? "Actualizando..." : "Añadiendo..."}
                </>
              ) : (
                <>
                  <i className={`bi ${editMode.isEditing ? 'bi-check-circle' : 'bi-plus-circle'} me-1`}></i>
                  {editMode.isEditing ? "Actualizar" : "Añadir"}
                </>
              )}
            </Button>
            {editMode.isEditing && (
              <Button variant="outline-secondary" onClick={() => setEditMode({ isEditing: false, preguntaId: null })}>
                <i className="bi bi-x-circle me-1"></i>
                Cancelar
              </Button>
            )}
          </div>

          <hr />
          <h5>Preguntas:</h5>
          <div className="table-responsive">
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Pregunta</th>
                  <th>Tipo</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {(preguntas[selectedEncuestaId] || []).map((preg) => (
                  <tr key={preg.id}>
                    <td>{preg.pregunta}</td>
                    <td>
                      {preg.tipo_respuesta === 'opcion_multiple' ? 'Opción múltiple' : 'Abierta'}
                      {preg.tipo_respuesta === 'opcion_multiple' && preg.alternativas && (
                        <ul className="mb-0">
                          {normalizeAlternativas(preg.alternativas).map((alt, index) => (
                            <li key={index}>{alt}</li>
                          ))}
                        </ul>
                      )}
                    </td>
                    <td className="text-nowrap">
                      <ButtonGroup size="sm">
                        <Button
                          variant="outline-warning"
                          onClick={() =>
                            handleEditarPregunta(preg.id, preg.pregunta, preg.tipo_respuesta, preg.alternativas)
                          }
                          title="Editar"
                        >
                          <i className="bi bi-pencil"></i>
                        </Button>
                        <Button
                          variant="outline-danger"
                          onClick={() => handleEliminarPregunta(preg.id)}
                          title="Eliminar"
                        >
                          <i className="bi bi-trash"></i>
                        </Button>
                      </ButtonGroup>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => handleShowModal('showPreguntaModal', false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EncuestasPage;